import { render, staticRenderFns } from "./SavedCards.vue?vue&type=template&id=b8036336&scoped=true"
import script from "./SavedCards.vue?vue&type=script&lang=js"
export * from "./SavedCards.vue?vue&type=script&lang=js"
import style0 from "./SavedCards.vue?vue&type=style&index=0&id=b8036336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8036336",
  null
  
)

export default component.exports